<h1 mat-dialog-title>
  <i class="far fa-exclamation-triangle i-16 mr-4"></i>
  <span>Alert</span>
</h1>
<div mat-dialog-content class="text-center c-grey-5 fs-14">
  <ng-container *ngIf="loading">
    <app-spinner></app-spinner>
  </ng-container>
  <ng-container *ngIf="!loading">
    <div class="mt-20">
      <span>
        The dataset could not be verified.<br />
        Please edit it, then address any issues to proceed.
      </span>
    </div>
    <div *ngIf="canSeeDetails" class="mt-10">
      <span class="c-blue bold pointer" [hidden]="detailsExpanded" (click)="detailsExpanded = true">
        View details
      </span>
      <div [hidden]="!detailsExpanded">
        <div *ngFor="let i of details" [innerHTML]="i"></div>
      </div>
    </div>
  </ng-container>
</div>
<div mat-dialog-actions align="center">
  <button trgButton color="primary" class="min-w-100" (click)="close()" cdkFocusInitial [disabled]="loading">Close</button>
</div>
